import React, { Suspense } from 'react';
import PrimaryButtonComponent from '../../../Components/Buttons/PrimaryButton/PrimaryButton.component';
import SecondaryButton from '../../../Components/Buttons/SecondaryButton/SecondaryButton.component';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { handleDownload } from '../../Certificates/Certificate/GenerateCert.jsx';
import { generateCertBlob } from '../../Certificates/Certificate/GenerateBlob.jsx';
import { httpUploadCertificate } from '../../../Hooks/user/user.post.hooks.js';
import { ButtonContainers } from './ComInc.styles.jsx';
//  course,
const CompleteButtons = ({ userInfo }) => {
  const navigate = useNavigate();
  const generateAndUploadCertificate = async () => {
    if (
      userInfo &&
      userInfo?.courses?.[0]?.courseName &&
      userInfo?.courses?.[0]?.certNum &&
      !userInfo.courses?.[0]?.courseName?.includes('TDG')
    ) {
      const { courseName, date, expiryDate, certNum, courseId } =
        userInfo.courses[0];
      const name = `${userInfo?.firstName} ${userInfo?.lastName}`;
      const pdfBlob = await generateCertBlob(
        name,
        courseName,
        date,
        expiryDate,
        certNum
      );
      const formData = new FormData();
      formData.append('certificate', pdfBlob, `${name}-${courseName}.pdf`);
      formData.append('userId', userInfo?._id);
      formData.append('courseId', courseId);
      await httpUploadCertificate(formData);
    }
  };
  const downloadCertificate = async () => {
    handleDownload(name, courseName, dateCompleted, expiryDate, certNumber);
    await generateAndUploadCertificate();
  };

  const courseName = userInfo?.courses?.[0]?.courseName;
  const name = `${userInfo?.firstName} ${userInfo?.lastName}`;
  const dateCompleted = userInfo?.courses?.[0]?.date;
  const expiryDate = userInfo?.courses?.[0]?.expiryDate;
  const certNumber = userInfo?.courses?.[0]?.certNum;

  const homeLink = () => {
    navigate('/user');
  };

  return (
    <ButtonContainers>
      <Suspense fallback={<div>Loading button...</div>}>
        <SecondaryButton span="Home" functionName={homeLink} />
      </Suspense>
      <Suspense fallback={<div>Loading button...</div>}>
        <PrimaryButtonComponent
          span="Download Certificate"
          functionName={downloadCertificate}
        />
      </Suspense>
    </ButtonContainers>
  );
};
CompleteButtons.propTypes = {
  userInfo: PropTypes.object,
  course: PropTypes.object,
};

export default CompleteButtons;
